import { useEffect, useState, useRef } from 'react';
import '../assets/styles/login.css';
import { sc } from '../helper/constants';

const LoginScreen = ({setNames, setScreen, setScore, setHistory}) => {
  // newNames is used to store names being put in input fields, not to change global names from before
  const [newNames, setNewNames] = useState({player1: '', player2: ''});

  // Result of checking, if user put input in both fields players names
  const [fieldsFull, setFieldsFull] = useState(false);
  // References to input fields to access users input
  const inputPlayer1 = useRef();
  const inputPlayer2 = useRef();
  
  // Check, if both players fields contain some input and set fieldsFull accordingly
  useEffect(() => {
    if (newNames.player1.length > 0 && newNames.player2.length > 0) {
      setFieldsFull(true);
    } else {
      setFieldsFull(false);
    }
  }, [newNames]);

  // setNames is setter for players names from App.js and handles transfering player names to global state
  // Also change screen to board
  const handleSubmit = (event) => {
    event.preventDefault();
    setScore({player1: 0, player2: 0, ties: 0});
    setHistory([]);
    setNames({
      player1: inputPlayer1.current.value,
      player2: inputPlayer2.current.value
    });
    setScreen(sc.board);
  }

  // Handling typing inputs to players names
  const changeHandler = (e) => {
    setNewNames({
      ...newNames,
      [e.target.name]: e.target.value
    });
  }

  return (
    <div className="login" >
      <form onSubmit={handleSubmit}>
        <div className='input-container'>
          <label>Name Player 1</label>
          <input type="text" name="player1" required ref={inputPlayer1} value={newNames.player1} onChange={changeHandler} />
        </div>
        <div className='input-container'>
          <label>Name Player 2</label>
          <input type="text" name="player2" required ref={inputPlayer2} value={newNames.player2} onChange={changeHandler} />
        </div>
        <div className="button-container">
          <input disabled={!fieldsFull} type="submit" />
        </div>
      </form>
    </div> 
  );
}

export default LoginScreen;